"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const api = __importStar(require("./api"));
const chrono_1 = require("./chrono");
const exception_1 = require("./exception");
const exec_1 = require("./exec");
const parser_1 = require("./parser");
const quote_1 = require("./quote");
const value_1 = require("./value");
class Context {
    constructor(initializeDefaultRuntime = true) {
        this.data = [];
        this.dictionary = new Map();
        if (initializeDefaultRuntime) {
            this.install(api.boolean);
            this.install(api.date);
            this.install(api.month);
            this.install(api.number);
            this.install(api.quote);
            this.install(api.record);
            this.install(api.string);
            this.install(api.time);
            this.install(api.utils);
            this.install(api.vector);
            this.install(api.weekday);
        }
    }
    get length() {
        return this.data.length;
    }
    [Symbol.iterator]() {
        const data = this.data;
        let index = data.length;
        return {
            next() {
                --index;
                return {
                    done: index < 0,
                    value: data[index],
                };
            },
        };
    }
    clear() {
        this.data.length = 0;
    }
    peek(type) {
        if (!this.data.length) {
            throw new exception_1.RangeError("Stack underflow.");
        }
        const value = this.data[this.data.length - 1];
        if (type && value.type !== type) {
            throw new exception_1.TypeError(`Unexpected ${value.type.toLowerCase()}; Was expecting ${type.toLowerCase()}.`);
        }
        return value;
    }
    peekBoolean() {
        return this.peek("Boolean").value;
    }
    peekDate() {
        return this.peek("Date");
    }
    peekMonth() {
        return this.peek("Month").value;
    }
    peekNumber() {
        return this.peek("Number");
    }
    peekQuote() {
        return this.peek("Quote").quote;
    }
    peekRecord() {
        return this.peek("Record").elements;
    }
    peekString() {
        return this.peek("String").value;
    }
    peekTime() {
        return this.peek("Time");
    }
    peekVector() {
        return this.peek("Vector").elements;
    }
    peekWeekday() {
        return this.peek("Weekday").value;
    }
    pop(type) {
        if (!this.data.length) {
            throw new exception_1.RangeError("Stack underflow.");
        }
        const value = this.data.pop();
        if (type && value.type !== type) {
            throw new exception_1.TypeError(`Unexpected ${value.type.toLowerCase()}; Was expecting ${type.toLowerCase()}.`);
        }
        return value;
    }
    popBoolean() {
        return this.pop("Boolean").value;
    }
    popDate() {
        return this.pop("Date");
    }
    popMonth() {
        return this.pop("Month").value;
    }
    popNumber() {
        return this.pop("Number");
    }
    popQuote() {
        return this.pop("Quote").quote;
    }
    popRecord() {
        return this.pop("Record").elements;
    }
    popString() {
        return this.pop("String").value;
    }
    popTime() {
        return this.pop("Time");
    }
    popVector() {
        return this.pop("Vector").elements;
    }
    popWeekday() {
        return this.pop("Weekday").value;
    }
    push(...values) {
        this.data.push(...values);
    }
    pushBoolean(value = false) {
        this.data.push((0, value_1.newBooleanValue)(value));
    }
    pushDate(year = 1970, month = chrono_1.Month.January, day = 1) {
        this.data.push((0, value_1.newDateValue)(year, month, day));
    }
    pushMonth(value = chrono_1.Month.January) {
        this.data.push((0, value_1.newMonthValue)(value));
    }
    pushNumber(value = 0, unit) {
        this.data.push((0, value_1.newNumberValue)(value, unit));
    }
    pushQuote(quote) {
        this.data.push((0, value_1.newQuoteValue)(quote));
    }
    pushRecord(elements = []) {
        this.data.push((0, value_1.newRecordValue)(elements));
    }
    pushString(value = "") {
        this.data.push((0, value_1.newStringValue)(value));
    }
    pushTime(hour = 0, minute = 0, second = 0) {
        this.data.push((0, value_1.newTimeValue)(hour, minute, second));
    }
    pushVector(elements = []) {
        this.data.push((0, value_1.newVectorValue)(elements));
    }
    pushWeekday(value = chrono_1.Weekday.Sunday) {
        this.data.push((0, value_1.newWeekdayValue)(value));
    }
    exec(sourceCode, print = console.log, line = 1, column = 1) {
        let script;
        if (Array.isArray(sourceCode)) {
            script = sourceCode;
        }
        else {
            script = (0, parser_1.parse)(sourceCode, line, column);
        }
        (0, exec_1.execScript)(this, print, script);
    }
    get symbols() {
        return this.dictionary.keys();
    }
    lookup(id) {
        return this.dictionary.get(id);
    }
    define(id, value) {
        this.dictionary.set(id, value);
    }
    delete(id) {
        return this.dictionary.delete(id);
    }
    install(mapping) {
        for (const [name, callback] of mapping) {
            this.dictionary.set(name, (0, value_1.newQuoteValue)(new quote_1.BuiltinQuote(callback)));
        }
    }
}
exports.Context = Context;
